import i18n from '@/plugins/vue-i18n'
const emailRegExp =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const urlRegExp =
  /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/;

//此為必填項目
const required = (v, text = 'Required') => !!v || text;
const requiredNum = (v, text) => typeof v === 'number' || required(v, text);
//Email 格式錯誤
const email = (v, text = i18n.t('PAYMENT.WORD.INVALID_EMAIL_ADDRESS')) =>
  v ? emailRegExp.test(v) || text : true;
const url = (v, text = i18n.t('ARTWORK.EDIT.INPUT.ALERT.INVALID_URL_FORMAT')) =>
  v ? urlRegExp.test(v) || text : true;
  //長度不可超過
const maxLength = (v, length, text) =>
  `${v}` ? `${v}`.length <= length || text || `${i18n.t('ARTWORK.EDIT.INPUT.ALERT.LENGTH_CANNOT_EXCEED')} ${length}` : true;
const minLength = (v, length, text) =>
  `${v}` ? `${v}`.length >= length || text || `${i18n.t('ARTWORK.EDIT.INPUT.ALERT.LENGTH_CANNOT_EXCEED')} ${length}` : true;

export default {
  required,
  requiredNum,
  email,
  url,
  maxLength,
  minLength
};
